import axios from 'axios';

const getSingleStoreApi = async (paramsFilter, token, langIsoCode) => {
  try {
    const url = `/Store/single?store_id=${
      paramsFilter?.store_id ? paramsFilter.store_id : ''
    }&page=${paramsFilter?.page ? paramsFilter.page : ''}`;
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getSingleStoreApi;
